export default {
  title: {
    en: 'All the designer fragrances you can imagine in one place',
  },
  subTitle: {
    en: 'Check out our brand portfolio below.',
  },
  text: {
    en: `
    Scentbird, Inc. is wholly independent and separate from the designer or the designer's manufacturers.
    Scentbird states that the contents are genuine product independently rebottled by Scentbird, Inc.,
    New York, NY 10001
  `,
  },
}
